import {
    Box,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
} from "@chakra-ui/react";
import React from "react";
import Player from "../../vdoPlayer/player";
import { useEffect, useState } from "react";
import axiosInstance from "../../../helpers/api";
import YouTubeEmbed from "../../../components/YouTubeEmbed";

const VideoPreviewModal = ({ isOpen, onClose, videoData }) => {
    const [loading, setLoading] = useState(true);
    const [otp, setOtp] = useState("");
    const [playBack, setPlayBack] = useState("");
    const videoType = Number(videoData?.video_type);

    const getVideoData = async (id) => {
        setLoading(true);
        const res = await axiosInstance.get(`/admin/videos/otp/${id}`);

        await setOtp(res?.data?.otp);
        await setPlayBack(res?.data?.playbackInfo);
        setTimeout(() => {
            setLoading(false);
        }, 2000);
    };

    useEffect(() => {
        if (videoData?.id && videoType === 1) getVideoData(videoData?.id);
    }, [videoData?.id, videoType]);

    const renderVideoPreview = () => {
        if (videoType === 1) {
            return loading ? null : (
                <Player
                    otp={otp}
                    playbackInfo={playBack}
                    data={videoData}
                />
            );
        }

        if (videoType === 0 || videoType === 2) {
            return (
                <YouTubeEmbed
                    videoUrl={videoData?.url}
                    videoType={videoType}
                    unrestricted
                />
            );
        }

        return <div dangerouslySetInnerHTML={{ __html: videoData?.url }}></div>;
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="xl">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{videoData?.title}</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <Box bg="gray" w="100%" borderRadius="8px" mb={4}>
                        {renderVideoPreview()}
                    </Box>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default VideoPreviewModal;